import { createApp } from 'vue';
import SvgIcon from './components/SvgIcon.vue';
import 'es6-promise/auto';
import router from './router';
import store from './store';
import App from './App.vue';
import './assets/css/mobile.css';

/* eslint-disable */
import 'vite-plugin-svg-icons/register';
/* eslint-enable */

// 设置字体颜色
const titleColor = import.meta.env.VITE_TITLE_COLOR;
const sourceTimeColor = import.meta.env.VITE_SOURCE_TIME_COLOR;
const h5Title = import.meta.env.VITE_H5_TITLE;
document.title = h5Title;

if (titleColor) {
  document.getElementsByTagName('body')[0].style.setProperty('--titleColor', titleColor);
}
if (sourceTimeColor) {
  document.getElementsByTagName('body')[0].style.setProperty('--sourceTimeColor', sourceTimeColor);
}

const app = createApp(App);
app.component('svg-icon', SvgIcon);
app.use(router).use(store).mount('#app');
